import { useState, type ReactElement } from 'react';
import type { OnlineUsersDto } from '@gr/core/platform/admin/dto';
import { RealtimeMessageType } from '@gr/core/platform/system/realtime';
import { useRealtimeMessages, useServices, useT, useWatchOnline } from '../../../app/di';
import { formatDateTime } from '../../../shared/format';
import { useResource } from '../../../shared/hooks';
import { Alert } from '../../../ui-kit/Alert/Alert';
import { Button } from '../../../ui-kit/Button/Button';
import { Loading } from '../../../ui-kit/Loading/Loading';
import { PageHeader } from '../../../ui-kit/PageHeader/PageHeader';
import { PlatformOnline } from './PlatformOnline/PlatformOnline';

// ADM-UC-3, ADM-UC-3.CC-1: пока страница открыта, соединение событий следит за «Онлайн», и сервер сам
// присылает свежий список. Запрос — только первый показ (связь могла ещё не открыться) и «Обновить».
export function AdminOnlinePage(): ReactElement {
  const { api } = useServices();
  const { t, te, locale } = useT();
  const loaded = useResource(() => api.admin.online(), [api]);
  const [pushed, setPushed] = useState<OnlineUsersDto | null>(null);
  useWatchOnline();
  useRealtimeMessages((message) => {
    if (message.type === RealtimeMessageType.OnlineUsers) setPushed({ generatedAt: message.generatedAt, users: message.users });
  });
  // Свежее из двух: список по соединению или ответ на запрос.
  const online = pushed && (!loaded.data || pushed.generatedAt >= loaded.data.generatedAt) ? pushed : loaded.data;

  return (
    <div className="u-stack-lg">
      <PageHeader
        title={t('admin.online.title')}
        subtitle={online ? `${t('admin.online.subtitle')} ${t('admin.overview.generatedAt', { time: formatDateTime(online.generatedAt, locale) })}` : t('admin.online.subtitle')}
        actions={
          <Button icon="search" loading={loaded.loading} onClick={() => void loaded.reload()}>
            {t('admin.overview.refresh')}
          </Button>
        }
      />
      {online ? (
        <PlatformOnline users={online.users} />
      ) : loaded.loading ? (
        <Loading label={t('common.loading')} />
      ) : (
        <Alert tone="danger" title={t('common.loadFailed')}>
          {te(loaded.error)}
        </Alert>
      )}
    </div>
  );
}
